import styled from 'styled-components';

export const StatsWrapper = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;

  & > * {
    flex: 0 1 calc(50% - 8px);
  }

  @media ${({ theme }) => theme.media.landscapeMobile} {
    gap: 36px;

    & > * {
      flex: 0 1 calc(33.333% - 24px);
    }
  }
`;

export const StatItem = styled.div`
  text-align: center;
`;

export const StatNumber = styled.div`
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 6px;

  @media ${({ theme }) => theme.media.landscapeMobile} {
    font-size: 48px;
    margin-bottom: 12px;
  }
`;

export const StatDescription = styled.div`
  font-size: 13px;

  @media ${({ theme }) => theme.media.landscapeMobile} {
    font-size: 16px;
  }
`;
